export const awardConstants = {
    START: 'award:start',
    STOP: 'award:stop',
    AWARD: 'award:award',
    ADD: 'award:add',
    UPDATE: 'award:update',
    REMOVE: 'award:delete',
    CLEAR: 'award:clear',
};
